module.exports = __webpack_public_path__ + "img/lock-white.bdbaa660.svg";